
var SparkMD5 = require('../vendor/spark-md5');
const Cookies = require( '../vendor/js.cookie' )
var versionInfo = require('src/version');
import SETTINGS from "settings"

/** Каждые сколько секунд, по меньшей мере, от сервера должно быть получено текущее количество кредитов.*/
var CREDITS_POLL = 5;

export const cookiesSettings =
{
    path : "/",
    domain : undefined,
    expires : 2 * 365,
};

export const cookies =
{
    get : function( name, silently, json )
    {
        if ( LOBBYLESS_ENV )
        {
            switch ( name )
            {
                case "session_id":
                    return this.session_id;
                case "refresh_token":
                    return this.refresh_token;
            }
        }
        
        var cookie = Cookies.get( name, cookiesSettings );
        if ( typeof cookie === 'string' )
        {
            var result = cookie.split( "|" );
            //console.log( "Cookie \"" + name + "\" obtained as \"" + result[ 0 ] + "\" under \"" + result[ 1 ] + "\"." );
            
            if ( json ) {
                try { return JSON.parse( decodeURIComponent( result[ 0 ] ) ) }
                catch( e ) { return 'Cookie ' + name + ' read failed: ' + JSON.stringify( e ) }
            }
            
            return result[ 0 ];
        }
        if ( ! silently ) console.error( "Obtaining cookie \"" + name + "\" is NOT of type string, it's " + ( typeof cookie ) + ", value = " + cookie );
        return undefined;
    },

    set : function( name, value, place )
    {
        if ( LOBBYLESS_ENV )
        {
            switch ( name )
            {
                case "session_id":
                    this.session_id = value;
                    return;

                case "refresh_token":
                    this.refresh_token = value;
                    return;
            }
        }
        
        //console.log( "Setting cookie \"" + name + "\" to \"" + value + "\" under \"" + place + "\"." );
        Cookies.set( name, value/* + "|" + place*/, cookiesSettings );
    }
};

export const OPERATION_ID =
{
    SESSION_START_LOGIN : 100,
    SESSION_START_TERMINAL : 110,
    SESSION_START_CARD_AND_TERMINAL : 120,
    SESSION_START_SPORT_BET : 122,
    
    SESSION_REFRESH : 130,
    SESSION_CLOSE : 140,

    USER_SETTINGS_SET : 200,
    USER_SETTINGS_GET : 210,
    STATE_GET : 220,
    STATE_PREVIOUS_GET : 230,
    SCENARIO_GAME_BEGIN : 240,
    WAY_SELECT : 250,
    SCENARIO_RISK_BEGIN : 260,
    SCENARIO_SKIP_TO_RISK : 265,
    SPECIFICATION_GET : 270,
    WIN_TABLE_GET : 271,
    CLIENT_DATA_APP_SET : 280,
    CLIENT_DATA_APP_GET : 290,

    CLIENT_DATA_SCENARIO_SET : 300,
    CLIENT_DATA_SCENARIO_GET : 310,
    RISK_HISTORY_GET : 320,
    WATCH_RECORDS_GET : 330,
    STEP_CHECK : 340,
    PROFILE : 360,

    BALANCE_GET : 400,
    PROGRESSIVE_JACKPOT_GET : 401,
    CODE_ACTIVATE : 410,
    CODE_GENERATE : 420,
    CODE_HISTORY : 430,
    BET_HISTORY_GET : 440,
    TICKET_HISTORY_GET: 442,
};
function operationName( operationId )
{
    for ( var name in OPERATION_ID )
    {
        if ( OPERATION_ID[ name ] == operationId )
        {
            return name;
        }
    }

    return "UNKNOWN OPERATION";
}

function is_session_start( operation_id ) {
    return [
        OPERATION_ID.SESSION_START_LOGIN,
        OPERATION_ID.SESSION_START_TERMINAL,
        OPERATION_ID.SESSION_START_CARD_AND_TERMINAL,
    ].includes( operation_id )
}

/**
    * Process server response invoking corresponding handlers for every requested operation.
    * @param response Server response decoded JSON data
    * @param {ReadyRequest} readyRequest
    * @return {Boolean} true if request needs to be resent
    */
function handleResponse(
    response,
    readyRequest
)
{
    {
        const debug = response.debug
        if ( debug && debug.log_url && ! SETTINGS.isMobile ) console.log( debug.log_url )
    }
    
    readyRequest.server.lastCreditsUpdate = Date.now();

    readyRequest.server.creditsBeingUpdated = false;
    
    //no matter how messages was ordered:
    delete readyRequest.server.sessionRefreshPending

    if ( response.hasOwnProperty( "success" ) && response.success == false )
    {
        readyRequest.server.enterFatal( readyRequest.onFatal, response.error ? response.error.message : "unknown message" );
        return;
    }

    if ( ! response.service )
    {
        //в ответах на trace сервер не присылает даже "service" part, а в таких (trace) запросах ни onResult ни onError/onFatal никому не интересны:
        if ( readyRequest.onFatal instanceof Function )
        {
            readyRequest.server.enterFatal( readyRequest.onFatal, "no service part" );
        }
        return;
    }

    //checking the service part:
    if ( response.service.hasOwnProperty( "success" ) && response.service.success == false )
    {
        //ERROR_REQUEST_ALREADY_IN_QUEUE: сервер слишком сильно нагружен и не успел обработать подобный запрос в рамках timeout'а и на новый [пере]запрос ответил что он ещё обрабатывает предыдущий, поэтому нужно подождать и спросить заново:
        if ( response.service.error && response.service.error.code == 110 )
        {
            return true;
        }
        
        //ERROR_SESSION_NOT_FOUND может сопровождаться URL'ом для перенаправления:
        if ( response.service.error && response.service.error.code == 300 )
        {
            if ( response.service.error.details && response.service.error.details.redirect_url )
            {
                readyRequest.server.enterFatal(
                    readyRequest.onFatal,
                    response.service.error.message,
                    false,
                    response.service.error.details.redirect_url
                );
                return;
            }
        }

        readyRequest.server.enterFatal( readyRequest.onFatal, response.service.error.message );
        return;
    }

    //при обновлении сессии сервер в "service" возвращает остаток жизни сессии, которую и обновляли (а не той НА которую обновились), поэтому клиент (то есть "мы") может подумать что сессию опять нужно обновить, однако договорились что сервер в самом operation'е обновления сессии будет также возвращать остаток жизни УЖЕ НОВОЙ сессии, поэтому важно чтобы эта строчка была ПЕРЕД обработкой operation'ов:
    readyRequest.server.sessionTimeLeft = response.service.result.session_time_left;
    
    if ( ! response.main )
    {
        readyRequest.server.enterFatal( readyRequest.onFatal, "no \"main\" part" )
        return
    }

    if ( response.main && response.main.hasOwnProperty( "success" ) && response.main.success == false )
    {
        readyRequest.server.enterFatal( readyRequest.onFatal, response.main.error.message );
        return;
    }
    
    //reactive bindings:
    var type = undefined;
    var state = undefined;
    var balance = undefined;
    let jackpot_progressive = undefined

    //раздаём все части ответа всем получателям:
    response.main.result.operations.forEach( function( operation )
    {
        //if within some previous receiver error has been detected:
        if ( readyRequest.server.ok !== true )
        {
            return;
        }

        if ( operation.success !== true )
        {
            switch ( operation.error.code )
            {
                //ERROR_CREDITS_TOO_MUCH "Если кредитов больше лобби должна вывести сообщение пользователю что играть дальше нельзя пока кредитов не станет меньше чем gamable_limit":
                case 510:
                    readyRequest.server.enterFatal( readyRequest.onFatal, 'ERROR_CREDITS_TOO_MUCH' );
                    return;
                //"You need set session_id":
                case 300:
                    readyRequest.server.enterFatal( readyRequest.onFatal, operation.error );
                    return;
                default:
                    readyRequest.server.enterFail( readyRequest.onFail, "Operation " + operationName( operation.id ) + " failed on server: " + JSON.stringify( operation.error ) );
                    return;
            }
        }
        
        if ( operation.result && operation.result.credential ) {
            console.log( '⚡⚡⚡ redefining credential to:', operation.result.credential )
            cookies.set( 'credential', operation.result.credential )
            readyRequest.server.credential = operation.result.credential
        }

        //ИМЕННО при логине session_time_left корректно указывается только в operation'е самого логина, а в service == null:
        if ( ! readyRequest.server.sessionTimeLeft )
        {
            if ( is_session_start( operation.id ) )
            {
                try
                {
                    readyRequest.server.sessionTimeLeft = operation.result.session_time_left;
                }
                catch ( e )
                {
                    console.error( "⚡⚡⚡ Session time left read fail: " + e );
                }
            }
        }

        switch ( operation.id )
        {
            case OPERATION_ID.STATE_GET:
                //in case of "totalizator" math server may respond with "wait a bit", so just ignore it:
                if ( ! operation.result.stage ) break
                
                readyRequest.server.step_id = operation.result.step_id;
                type = operation.result.stage.type_id;
                state = operation.result;
                readyRequest.server.stateOrder = readyRequest.server.stateOrder ? readyRequest.server.stateOrder + 1 : 1;
                break;
                
            case OPERATION_ID.BALANCE_GET:
                balance = operation.result;
                break;
            
            case OPERATION_ID.PROGRESSIVE_JACKPOT_GET:
                readyRequest.server.$progressive_jackpot.next( operation.result )
                break
            
            case OPERATION_ID.SESSION_START_SPORT_BET:
                if ( operation.result.session_id ) cookies.set( 'session_id', operation.result.session_id )
                break
        }

        //looking for specified Receiver:
        for ( var receiverIndex in readyRequest.requestData.receivers )
        {
            if ( readyRequest.requestData.receivers.hasOwnProperty( receiverIndex ) == false )
            {
                continue;
            }

            var receiver = readyRequest.requestData.receivers[ receiverIndex ];

            if ( receiver.operationId == operation.id )
            {
                receiver.callback( operation.result );
                delete readyRequest.requestData.receivers[ receiverIndex ];
            }
        }
    } );

    if ( readyRequest.server.ok !== true )
    {
        return;
    }

    if ( readyRequest.onSuccess !== undefined )
    {
        readyRequest.onSuccess();
    }
    
    if ( type !== undefined )
    {
        const lastNetState = {
            server : readyRequest.server,
            type,
            response,
            state,
        };
        if ( readyRequest.server.lastNetState ) {
            delete readyRequest.server.lastNetState.state.server
            delete readyRequest.server.lastNetState.state.state
            delete readyRequest.server.lastNetState.state.response
            delete readyRequest.server.lastNetState.state
        }
        readyRequest.server.lastNetState = lastNetState;
        readyRequest.server.$net.next( {
            state : lastNetState,
            balance,
            jackpot_progressive
        } );
        console.log( 'NET:', readyRequest.server.$net.value )
    }
}

const ATTEMPTS = 6
/** Effort to actually SEND (network-wise) the request and maybe try later if it failed within the specified amount of retries.
    * @param {ReadyRequest} readyRequest
    * @param {Number} tryCount How much attempts left to make before giving up and reporting onFail
    */
function issueRequest(
    readyRequest,
    tryCount
)
{
    let url = readyRequest.server.url
    if ( ! ( typeof url === 'string' || url instanceof String ) || url.length < 1 ) {
        console.error( 'issueRequest(): url is not proper:', url )
        return
    }
    
    tryCount = tryCount === undefined ? ATTEMPTS : tryCount;
    -- tryCount;

    const ajaxRequest =
    {
        type : 'POST',
        url,
        timeout : readyRequest.timeout ? readyRequest.timeout : 3000,
        xhrFields : {
            withCredentials : true
        }
    }

    //попросили для trace запросов добавить параметр URL'а:
    if ( readyRequest.requestData.data.service.client_trace )
    {
        var sendLogs = 'trace="send logs"';
        if ( url.indexOf( '?' ) >= 0 )
        {
            sendLogs = '&' + sendLogs;
        }
        else
        {
            sendLogs = '?' + sendLogs;
        }
        url += sendLogs;
    }

    //preliminary JSONing to compute hash to sign:
    //подписывать на основе хэша нужно только один раз, иначе подпись "уплывёт":
    if ( ! readyRequest.signed )
    {
        var jsonRequest = JSON.stringify( readyRequest.requestData.data );
        //signing final request:
        readyRequest.requestData.data.service.security.sign = SparkMD5.hash( jsonRequest );

        readyRequest.signed = JSON.stringify( readyRequest.requestData.data );
    }

    ajaxRequest.data = readyRequest.signed;

    ajaxRequest.contentType = "application/json";
    ajaxRequest.dataType = "json";
    
    //invalidate all the polling requests:
    if ( ! readyRequest.mayBecomeOutdated ) {
        const rk = readyRequest.server.requests.keys()
        for ( const r of rk ) {
            if ( r.mayBecomeOutdated ) {
                console.log( '⚡⚡⚡ Drop:', r.requestData.data )
                r.one_way = true
                readyRequest.server.requests.delete( r )
            }
        }
    }
    readyRequest.server.requests.add( readyRequest )

    let actualRequest = readyRequest.server.net_service( ajaxRequest )
    
    function clean_up()
    {
        readyRequest.server.requests.delete( readyRequest )
        
        const server = readyRequest.server
        for ( const i in readyRequest ) delete readyRequest[ i ]
        for ( const i in ajaxRequest ) delete ajaxRequest[ i ]
        continueCommunication( server )
    }

    actualRequest.done( function( data, textStatus, xhr )
    {
        if ( readyRequest.one_way )
        {
            clean_up()
            return
        }
        
        const server = readyRequest.server
        
        //console.log( "⚡⚡⚡ Request #" + tryCount + " succeeded." );

        //вроде как всегда именно DONE, но пусть живёт атавизм:
        if ( xhr.readyState != XMLHttpRequest.DONE )
        {
            clean_up()
            return
        }
        
        if ( xhr.status != 200 )
        {
            server.enterFatal( readyRequest.onFatal, "Wrong status: " + xhr.status + ", status text: " + xhr.statusText );
            clean_up()
            return;
        }

        let resend = false;
        
        //иногда прямо в обработке ответа от сервера могут выполняться попытки совершить очередной запрос на сервер, однако наличие запроса, на который сейчас обрабатывается ответ, в списке активных запросов запретит отправлять очередной запрос из-за запрета на наличие больше одного запроса (JavaScrip не позволяет выполнить композицию никак независимых друг от друга функций ("сетевая часть" и "логика игры") таким образом чтобы порядок выполнения кода не играл роли):
        readyRequest.server.requests.delete( readyRequest )

        //TODO: это довольно опасный код и хочется чтобы вызов не просто провалился в небытие, а сообщил об ошибке в графическую часть, поэтому нужно вернуть try/catch, а сейчас нужно посмотреть причину многочисленных ошибок:
        /*try
            {*/
        resend = handleResponse(
            data,
            readyRequest
        );
        /*}
            catch( e )
            {
            onFail( e.message );
            }*/

        if ( resend === true )
        {
            if ( tryCount > 0 )
            {
                setTimeout(
                    function ()
                    {
                        issueRequest(
                            readyRequest,
                            tryCount
                        );
                    },
                    1000
                );
            }
            else
            {
                server.enterFail( readyRequest.onFail, 'All resend attempts failed after', ATTEMPTS, 'tries' );
                clean_up()
            }
        }
        else
        {
            clean_up()
        }
        
        continueCommunication( server )
    } );
    actualRequest.fail( function( xhr, textStatus, errorThrown )
    {
        if ( readyRequest.one_way )
        {
            clean_up()
            return
        }
        
        const server = readyRequest.server
        
        //для " 'NO CONNECTION' не раньше чем через 7 секунд" (есть предположения что при отсутствии доступа к сети Ajax возвращает ошибку мгновенно, а не через timeout):
        const delay = 7000 / ( ATTEMPTS - 1 );

        //прежде такая ошибка возникала крайне редко и только при тестировании на планшете с Wi-Fi, но, как, вроде бы, стало понятно, такая ошибка возникает при отключении сети:
        if ( errorThrown === '' )
        {
            console.error( "⚡⚡⚡ Ajax' anonymous error. Probably network failure." );
            //не всегда проблемы с сетью отображаются как ошибка с пустой строкой - попытки плюс задержки всё-равно выравнены на " 'NO CONNECTION' не раньше чем через 7 секунд":
            /*//пусть при проблемах с сетью будет у устройства больше шансов восстановить подключение:
            delay = 5000;*/
        }

        //слишком долго не получаем ответ:
        if (
            //пусть пока повторные попытки совершаются при ЛЮБОЙ технической неудаче:
            /*( textStatus == 'timeout'
            //иногда на планшетах случается феерическая ошибка неизвестной природы, где ajax возвращает пустую строку в виде текста ошибки. Надеемся что подход совершения повторных попытком подключения решит и эту проблему в том числе:
            || errorThrown == '' )
            && */tryCount > 0
        )
        {
            console.log( "⚡⚡⚡ Request failed: " + errorThrown + ", " + textStatus + ". Issuing retry #" + tryCount + ' in ' + delay + ' ms ...' );

            setTimeout(
                function()
                {
                    /*//только для логов в рамках текущей отладки/тестирования:
                    if ( ! readyRequest.server.retries )
                    {
                        readyRequest.server.retries = [];
                    }
                    readyRequest.server.retries.push( errorThrown );*/

                    issueRequest(
                        readyRequest,
                        tryCount
                    );
                },
                delay
            );
        }
        else
        {
            console.log( '⚡⚡⚡ No retries remaining to recover server communication.' );
            server.enterFail(
                readyRequest.onFail,
                "Server: request failed: status: " + textStatus + ", error: " + errorThrown + ". Request string: " + jsonRequest + ". responseText: " + xhr.responseText
            );
            
            clean_up()
        }
        
        continueCommunication( server )
    } );

    /*var retriesCount = 0;
    var retriesString = '';
    if ( readyRequest.server.retries )
    {
        retriesCount = readyRequest.server.retries.length;
        retriesString += '| ';
        for ( var retryIndex in readyRequest.server.retries )
        {
            if ( readyRequest.server.retries.hasOwnProperty( retryIndex ) )
            {
                retriesString += readyRequest.server.retries[ retryIndex ] + ' | ';
            }
        }
    }
    console.log( "⚡⚡⚡ Request #" + tryCount + " sent. Gross " + retriesCount + " retries: " + retriesString );*/
}

function continueCommunication( server )
{
    //in case session refreshing message on it's own failed to commute:
    if ( ! server.ok ) return
    
    //no actually queues - only one postponement is allowed and supported:
    if ( ! server.postponedRequest ) return
    
    //if any communication still happening (for example polling with session refreshing) then need to wait:
    const rk = server.requests.keys()
    for ( const r of rk ) {
        if ( ! r.mayBecomeOutdated ) return
    }
    
    const p = server.postponedRequest
    delete server.postponedRequest
    p()
}

//was told that it's obligatory to add leading zeroes (but it works without):
function pad( num )
{
    let s = num + "";
    while ( s.length < 2 ) s = "0" + s;
    return s;
}

function GeneralRequest( server )
{
    var date = new Date;
    var utcDate =
        date.getFullYear() + "-" +
        pad( date.getMonth() + 1 ) + "-" +
        pad( date.getDay() ) + " " +
        pad( date.getHours() ) + ":" +
        pad( date.getMinutes() ) + ":" +
        pad( date.getSeconds() );

    return {
        data :
        {
            main : {
                operations : []
            },
            service : {
                header : {
                    protocol_version : "2.2",
                    session_id : cookies.get( "session_id" ) || "",
                    //server.credential будет undefined если логин осуществляется прямо из игры (без лобби):
                    credential : cookies.get( 'credential', undefined, true ) || {},
                    params : SETTINGS.url_params,
                    app : {
                        id : server.gameId,
                        version : versionInfo.build,
                        name : server.name || "not specified"
                    }
                },

                security : {
                    //теперь должно быть int32:
                    rand : Math.floor( Math.random() * 2147483648 ),
                    time : utcDate,
                    timestamp : Math.floor( date.getTime() / 1000.0 ),
                    //говорят что нужно именно сквозное время, а не просто микросекунды с произвольного момента (в данном случае - со старта страницы браузера):
                    //microtime : ( window.performance.now() * 1000.0 ),
                    //сказали что должен быть остаток от секунд:
                    microtime : ( date.getTime() % 1000 ) * 1000.0,
                    sign : "#490r876+YZ9xP",
                    client_id : 1,
                    disable_anti_spamming : ( server.disable_anti_spamming === undefined ? undefined : server.disable_anti_spamming ),
                },

                operations : []
            }
        },
        receivers : []
    };
}

/**
    * Make and send request. Single request may have many operations.
    * @param server
    * @param operationId Constant from OPERATION_ID. May be an Array if needs to send many operations within single request; onResult and params must be Arrays then.
    * @param onResult function( responseData : Object | NULL ) Null if request failed ( success == false or something else bad happened). Array of functions if operationId is Array.
    * @param params Optional operation parameters. Object. May be undefined. Keep order within Array with undefined values if need to specify some in case operationId is Array.
    * @param onSuccess Called at the very end of all operation callbacks calls.
    * @param onFail function( error : String ) If anything goes wrong at any stage, this is called. No onResult will be called after it.
    * @param trace Текстовое сообщение для отправки на сервер в качестве логирования происходящего на клиенте.
    * @param onFatal function( error : String ) Когда случается какая-то ошибка, после которой и не нужно пытаться восстановиться, а предложить игроку перейти в лобби.
    */
export function request(
    server,
    operationId,
    onResult,
    params,
    onSuccess,
    onFail,
    onFatal,
    trace,
    mayBecomeOutdated,
    one_way,
    timeout,
)
{
    if ( ! one_way )
    {
        if ( ! server.options || ! server.options.allow_multiple_requests ) {
            //если с сервером итак уже идёт общение по вопросам логики игры, то вызов других запросов в это время (обычно в этом же стеке) скорее-всего является ошибкой (результатом жмаканья клавиш с повешанными callback'ами на запрос к серверу, восстановление состояния с примесью предыдущего состояния и т.д.), поэтому попытаемся её решить просто игнорированием таких запросов - быть более стойкими к такого рода misuse'ам:
            const rk = server.requests.keys()
            for ( const r of rk ) {
                if ( ! r.mayBecomeOutdated ) {
                    console.trace( '⚡⚡⚡ Dropping request because some already pending.' );
                    server.restart( "Automatic recovering attempt after request drop" )
                    return;
                }
            }
        }
        //есть предположение что не дожидаясь успешного восстановления связи игра также делает вторичные запросы, а после возвращения связи - оба запроса проходят на сервер, что приводит к ошибке:
        if ( server.ok !== true )
        {
            console.trace( '⚡⚡⚡ Dropping request because server is NOT OK.' );
            server.restart( "Automatic recovering attempt after request drop because server was NOT OK" )
            return;
        }
        
        if ( server.sessionRefreshPending )
        {
            console.warn( '⚡⚡⚡ Postponing request because session refresh request pending ...' )
            server.postponedRequest = () => request.apply( null, arguments )
            return
        }
    }
    
    var requestData = new GeneralRequest( server );
    console.log( '⚡⚡⚡ request with credential:', requestData.data.service.header.credential )
    if ( is_session_start( operationId ) )
    {
        let id = 101
        
        //нужно было только для горбунка, но теперь появилась новая тотализаторная игра где это мешает (а горбунок больше не поддерживается):
        /*if ( server.totalizator ) id = 112
        else if ( server.tableMode ) id = 111*/
        
        if ( server.override_app_id ) id = server.override_app_id
        
        requestData.data.service.header.app.id = id
    }

    if ( trace !== undefined )
    {
        requestData.data.service.client_trace = trace;
    }

    if ( operationId instanceof Array )
    {
        //нужно сохранять гарантию того что команды будут отправлены на сервер в том же порядке что и назначены, поэтому итерируемся здесь через индекс, а не через "for each/in..." (второй способ не гарантирует сохранение порядка итерации):
        for ( var i = 0; i < operationId.length; ++ i )
        {
            addOperation(
                operationId[ i ],
                onResult === undefined ? undefined : onResult[ i ],
                params === undefined ? undefined : params[ i ],
                requestData,
                server
            );
        }
    }
    else if ( operationId !== undefined )
    {
        addOperation( operationId, onResult, params, requestData, server );
    }
    
    if ( ! one_way ) sessionKeep( server, requestData )

    issueRequest(
        {
            server,
            requestData,
            onSuccess,
            onFail,
            onFatal,
            mayBecomeOutdated,
            one_way,
            timeout,
        }
    )
}

//append another operation into the request:
/** Создать образец операции, пригодной для всех запросов и добавить её в указанный запрос.
    В одном запросе может быть сразу несколько операций.*/
function addOperation( operationId, callback, addingParams, requestData, server )
{
    const operation = {
        id : operationId,
        name : operationName( operationId ),
        params : {}
    };

    if ( addingParams !== undefined )
    {
        operation.params = addingParams;
    }
    //добавляем порядковый номер stage'а для реализации логики на сервере по верификации следования клиента по цепочке stage'ей внутри сценария чтобы два клиента под одним аккаунтом в одной игре не перезатирали клиентские данные друг друга:
    switch ( operationId )
    {
        case OPERATION_ID.SCENARIO_GAME_BEGIN:
        case OPERATION_ID.SCENARIO_RISK_BEGIN:
        case OPERATION_ID.WAY_SELECT:
            operation.params.step_id = server.step_id;
            break;
    }

    requestData.data.main.operations.push( operation );

    //receiver-less requests are okey when you send batch requests which is logically a single one:
    if ( callback !== undefined && callback !== null )
    {
        requestData.receivers.push( {
            operationId,
            callback
        } )
    }
}

function sessionKeep( server, requestData )
{
    //добавляем к запросу обновление сессии, если она вот-вот устареет:
    if ( server.sessionTimeLeft <= 0 )
    {
        //console.log( '⚡⚡⚡ Appending session refreshing operation ...' );
        
        addOperation(
            OPERATION_ID.SESSION_REFRESH,
            sessionRefresh =>
            {
                //с Евгением обсуждали что возможно в будущем эта команда будет возвращать новый refresh_token (а сейчас он пока старый остаётся) - зависит от приоритетов безопасности:
                //cookies.set( "refresh_token", sessionRefresh.refresh_token, "session refresh" );

                cookies.set( "session_id", sessionRefresh.session_id, "session refresh" );

                //нет смысла беспокоиться о других потенциальных читателях печенек, так как они всё-равно могут прочитать их между этой попыткой записи оных и их фактической записью, что приведёт к наличию двух разных идентификаторов сессий (если они решал что её пора обновить в этот момент), поэтому разрыв соединения в таком случае всё-равно неизбежен:
                /*//flush:
                while ( cookies.get( "session_id" ) !== sessionRefresh.session_id )
                {
                }*/

                server.sessionTimeLeft = sessionRefresh.session_time_left;
                
                //console.log( '⚡⚡⚡ Session successfully refreshed for ' + server.sessionTimeLeft + ' more time.' );
            },
            {
                refresh_token : cookies.get( "refresh_token" ),
                session_id : cookies.get( "session_id" ) || ""
            },
            requestData,
            server
        );
        
        server.sessionRefreshPending = true
    }
    else
    {
        //console.log( '⚡⚡⚡ No need to refresh session: ' + server.sessionTimeLeft + ' more time remaining ...' );
    }
}

const singleton = {}
function initCreditsPoll( server, options )
{
    /*//поллинг часто мешает отлаживать своими регулярными сообщениями, засоряя консоль: тут раскомментить можно блок чтобы его отключить на время дебага:
    if ( NODE_ENV === 'development' )
    {
        console.log( "CAUTION: polling is turned OFF now in development mode!" );
        return;
    }*/

    //отправляем запрос обновления кредитов если игрок сам их не инициирует:
    if ( singleton.poll_interval ) clearInterval( singleton.poll_interval )
    singleton.poll_interval = setInterval(
        () => poll( server, options ),
        // делить на 2 потому что из-за подсчёта времени с помощью Date.now() образовываются промежуточные состояния при которых баланс не запрашивается (так как 5 секунд ещё не прошло (не хватает несколько миллисекунд)):
        CREDITS_POLL * 1000 / 2
    );
}

export function init( server, options = {} )
{
    server.options = options
    
    server.virginSession = true
    
    //invalidate all the previous requests:
    const rk = server.requests.keys()
    for ( const r of rk ) {
        r.one_way = true
        server.requests.delete( r )
    }
    server.requests = new Set
    
    /** Случилось ошибка в общении с сервером, после которой нужно заново вызвать handleLobby() для восстановления состояния (просто повторного подключения к лобби).*/
    server.enterFail = function( onFail, message )
    {
        console.error( message )
        
        this.trace( message )

        this.ok = false;
        this.failed = Date.now();

        //бывают запросы на которые безразличен ответ, значит ничего не делаем:
        if ( onFail instanceof Function )
        {
            onFail( message );
        }
        else
        {
            console.error( "Enter fail: not a function :(" );
        }
        
        this.$error.next( { type : "fail", message } );
    };
    /** Случилась фатальная ошибка в общении сервером, после которой не нужно и пытаться восстановиться состояние, а просто показать игроку ошибку (или просто окошко о какой-то ошибке) и предложить вернуться в лобби.*/
    server.enterFatal = function( onFatal, message, instant, redirectUrl )
    {
        console.error( message )
        
        this.trace( message )
        
        if ( ! redirectUrl && SETTINGS.url_params[ 'deep_lobby_url' ] ) redirectUrl = decodeURIComponent( SETTINGS.url_params[ 'deep_lobby_url' ] )
        
        this.$error.next( {
            type : "fatal",
            message,
            redirectUrl
        } );

        //бывают запросы на которые безразличен ответ, значит ничего не делаем:
        if ( ! ( onFatal instanceof Function ) )
        {
            return;
        }

        this.ok = false;
        onFatal( message, instant, redirectUrl );
    };

    //в режиме мониторинга поллинг кредитов не имеет смысла (а сессия обновляется в рамках получения данных для мониторинга):
    if ( ! server.monitor && server.name != 'vendor' && ! options.no_poll )
    {
        initCreditsPoll( server, options );
    }
}

export function poll( server, options )
{
    //если общение с сервером встретило какую-то ошибку и ожидает восстановления:
    if ( server.failed !== undefined )
    {
        //console.log( 'POLLING: cannot due to server failed' )
        return;
    }

    //если сейчас общение с сервером перешло в ошибочное состояние и либо осуществляется реконнект либо фатал - поллинг бессмысленно:
    if ( server.ok !== true )
    {
        //console.log( 'POLLING: cannot due to server not OK' )
        return;
    }

    if ( server.requests.size > 0 )
    {
        //console.log( 'POLLING: cannot due to pending requests' )
        return
    }
    
    if ( ( Date.now() - server.lastCreditsUpdate ) < ( CREDITS_POLL * 1000 ) )
    {
        //console.log( 'POLLING: cannot due to recent message' )
        return
    }
    
    server.polling = true;
    
    const ops = []
    const cbs = []
    const pms = []
    function add( op, cb, pm ) {
        ops.push( op )
        cbs.push( cb )
        pms.push( pm )
    }
    
    if ( ! options.gameless && ! server.gameless ) add(
        OPERATION_ID.STEP_CHECK,
        undefined,
        {
            step_id : server.step_id
        }
    )
    add(
        OPERATION_ID.BALANCE_GET,
        function( balance )
        {
            //sometimes server drives it's own logic (skipping scenarios, etc) which may cause this whole message to fail due to SPEP_CHECK desync which causes incorrect balance display in respect to all the other visible parts of the game which will continue being visible until reconnection/reinit will happen in a short future (in several seconds):
            if ( ! server.ok ) return
            
            server.balance = balance;

            if ( server.onCreditsPoll instanceof Function )
            {
                server.onCreditsPoll( parseInt( balance.gameable ) );
            }
            
            server.$balancePoll.next( balance );
        },
    )
    add(
        OPERATION_ID.PROGRESSIVE_JACKPOT_GET,
    )
    if ( options.poll_settings ) add(
        OPERATION_ID.USER_SETTINGS_GET,
        settings => {
            if ( ! server.ok ) return
            server.$settings.next( settings )
        },
    )
    
    request(
        server,
        ops,
        cbs,
        pms,
        function()
        {
            server.polling = false;
        },
        function( errorString )
        {
            server.polling = false;
            
            if ( server.onFail instanceof Function )
            {
                server.onFail( "Error: request.init(): timer-wise balance polling failed: " + errorString );
            }
        },
        function( errorString )
        {
            server.polling = false;
            
            if ( server.onFatal instanceof Function )
            {
                server.onFatal( "Error: request.init(): time-wise balance polling failed: " + errorString );
            }
        },
        undefined,
        true
    )
}





// WEBPACK FOOTER //
// ./src/library/network/request.es6